import React from 'react';

const Home = () => (
  <div>
    <p>Track and manage your communication effectively.</p>
    <img
      src="https://plus.unsplash.com/premium_photo-1661589119272-31a4cabb6572?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      alt="Communication Illustration"
      className="welcome-image"
    />
  </div>
);

export default Home;
